import type { ICard } from "../../cardsSlice";

export const major21Card: ICard = {
    id: "major_21",
    arcana: "major",
    number: 21,
    suit: "major",
    court: "major",
    name: "Мир",
    nameEn: "The World",
    keywords: ["Завершение", "Целостность", "Освобождение"],
    symbolism: [
      "Фигура в венке из лавра",
      "Четыре существа в углах (евангелисты)",
      "Символ бесконечного танца"
    ],
    symbolismInterpretation:
      "Символ завершения цикла, освобождения и достижения целостности",
    archetype: "Архетип интеграции, исполненного предназначения, завершённого пути",
    psychology: "Принятие себя, соединение всех частей личности",
    upright: {
      personality: "Зрелость, гармония, уверенность",
      relationships: "Завершённый цикл, гармоничный союз",
      work: "Успешный финал проекта, признание",
      spirituality: "Целостность, достижение внутреннего единства",
      examples: ["Полный круг", "Венец усилий", "Интеграция опыта"]
    },
    reversed: {
      meaning: "Незавершённость, застой, невозможность завершить цикл",
      nuances: "Недостаток ясности, страх финала"
    },
    associations: ["Целое", "Венец", "Интеграция", "Достижение"],
    combinations: ["С Магом — завершённый путь от замысла к реализации", "С Колесом Фортуны — повторение цикла"],
    readingTips: ["Оценить, завершён ли процесс", "Понять, что целостность доступна"],
    selfQuestions: ["Где я чувствую завершённость?", "Что мне мешает отпраздновать результат?"]
  };


